import { PluginSidebar } from '@wordpress/editor'
import SidebarAutocomplete from './components/sidebar-autocomplete'
import SidebarFilters from './components/sidebar-filters'

export default function FilterSidebar(){
    return (
        <PluginSidebar
            name="filter-sidebar"
            title="Filtros"
            icon="admin-settings">
            <SidebarAutocomplete/>
            <SidebarFilters/>
        </PluginSidebar>
    );
};
